import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import {
    Link as RouterLink,
    useParams
} from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import LoadingPlaceholder from './LoadingPlaceholder';
import CurrentTimezoneIndicator from './CurrentTimezoneIndicator';
import { Container, Link } from '@mui/material';
import useCurrentUserDetails from '../../api/useCurrentUserDetails';
import { useGrowthBook } from '@growthbook/growthbook-react';

const MainPageContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100vh',
    minHeight: '100vh',
    overflowY: 'scroll'
});

const Footer = styled('div')(({ theme }) => ({
    marginTop: 32,
    marginBottom: 32,
    padding: 32,
    textAlign: 'center',
    color: theme.palette.grey[5],
    borderRadius: 12
}));

/** Lays out the "full" page - ie: including menu bars etc. */
const MainPageLayout = () => {
    const { isLoading: isLoadingUserDetails, userDetails } = useCurrentUserDetails();
    const { company_guid: companyId } = useParams();
    const growthbook = useGrowthBook();

    useEffect(() => {
        growthbook?.setAttributes({
            UserId: !isLoadingUserDetails && userDetails?.userId?.toUpperCase(),
            CompanyId: companyId?.toUpperCase()
        });
    }, [growthbook, companyId, isLoadingUserDetails, userDetails?.userId]);

    const loading = () => {
        return isLoadingUserDetails ? <LoadingPlaceholder /> : null;
    };

    return (
        <MainPageContainer id="VL-RootContainer">
            <main>
                { loading() || <Outlet /> }
            </main>

            <Container>
                <Footer>
                    <CurrentTimezoneIndicator />

                    <div style={{ padding: 4 }}>
                        <Link component={RouterLink} to={'/about'} underline="hover" sx={{ fontSize: '0.875rem' }}>
                            VisionsLive Portal v{ process.env.REACT_APP_VERSION }
                        </Link>
                    </div>
                </Footer>
            </Container>
        </MainPageContainer>
    );
};

export default MainPageLayout;
